import { FormInstance } from 'antd';

export const resetFields = (field: string, form: FormInstance<any>) => {
  switch (field) {
    case 'departmentId':
      return form.setFieldsValue({
        departmentId: undefined,
        jobId: undefined,
        jobLocationId: undefined,
      });
    case 'jobId':
      return form.setFieldsValue({ jobId: undefined, jobLocationId: undefined });
    case 'jobLocationId':
      return form.setFieldsValue({ jobLocationId: undefined });
    default:
      return;
  }
};
